<div class="fm-rs-steps">
  <div class="fm-page-title">
    <h2 class="fm-head-24 fm-title mb-2">Review & Edit Your Story</h2>
    <p>Review your recording, trim if needed, and tag people before publishing</p>
  </div>

  <div class="fm-card-wrapper">
    <div class="row">
      <div class="col-12 col-lg-7 col-xl-8">
        @if (mediaType() === 'video') {
        <div class="fm-white-column">
          <div class="fm-story-vplayer fm-rs-video-preview mt-4">
            @if (videoUrl()) {
              <video
                #reviewVideo
                class="fm-story-video"
                [src]="videoUrl()!"
                controls
                autoplay
                playsinline
                disablepictureinpicture
                disableremoteplayback
                controlslist="nodownload noplaybackrate"
                (loadedmetadata)="onVideoMetadataLoaded()"
                (canplay)="onVideoMetadataLoaded()"
                (timeupdate)="onVideoTimeUpdate()"
                (seeking)="onVideoSeeked()"
              ></video>
            } @else {
              <div class="fm-video-empty-state">
                <img src="images/icons/fm-video-lg.svg" class="fm-svg" alt="No Preview" />
                <p class="mb-0 mt-2">No recorded/uploaded media found. Please go back and record.</p>
              </div>
            }
          </div>
          <div class="fm-golden-column fm-trim-cl mt-4">
            <div class="row align-items-center g-3">
              <div class="col">
                <h3 class="fm-heading-sm"><img src="images/icons/fm-sizzer-cl.svg" alt="Trim Icon" /> Trim Video</h3>
              </div>
              <div class="col-auto">
                <button type="button" class="fm-common-btn fm-border-btn" (click)="resetTrim()">
                  <img src="images/icons/fm-reset.svg" alt="Reset Icon" /> Reset
                </button>
              </div>
              <div class="col-12">
                <p class="fm-small mt-1 mb-2">Drag sliders to set start and end points. Preview will play only in trimmed range.</p>
              </div>

              <div class="col-12 mb-2">
                <div class="fm-trim-strip-wrapper" #trimContainer>
                  <canvas #trimCanvas class="fm-trim-canvas"></canvas>
                  <!-- dark overlay: excluded left region -->
                  <div class="fm-trim-exclude fm-trim-left-exclude" [style.width.%]="trimStartPercent()"></div>
                  <!-- dark overlay: excluded right region -->
                  <div class="fm-trim-exclude fm-trim-right-exclude" [style.width.%]="trimEndExcludePercent()"></div>
                  <!-- selection border -->
                  <div class="fm-trim-selection"
                    [style.left.%]="trimStartPercent()"
                    [style.width.%]="trimSelectionWidth()"></div>
                  <!-- start handle -->
                  <div class="fm-trim-handle fm-trim-handle-start" [style.left.%]="trimStartPercent()"
                    (mousedown)="startDragging('start', $event)"
                    (touchstart)="startDragging('start', $event)">
                    <span class="fm-trim-handle-bar"></span>
                    <small class="fm-trim-time-label">{{ formatRecordingTime(trimStart()) }}</small>
                  </div>
                  <!-- end handle -->
                  <div class="fm-trim-handle fm-trim-handle-end" [style.left.%]="trimEndPercent()"
                    (mousedown)="startDragging('end', $event)"
                    (touchstart)="startDragging('end', $event)">
                    <span class="fm-trim-handle-bar"></span>
                    <small class="fm-trim-time-label">{{ formatRecordingTime(trimEnd()) }}</small>
                  </div>
                </div>
              </div>

              <div class="col-sm">
                <p class="fm-duretion-txt mb-0">
                  New duration: <span class="fw-semibold">{{ formatRecordingTime(trimmedDuration()) }}</span>
                  (removed {{ formatRecordingTime(removedDuration()) }})
                </p>
              </div>
              <div class="col-sm-auto">
                <div class="fm-btn-group">
                  <button type="button" class="fm-common-btn fm-border-btn" (click)="resetTrim()">Cancel</button>
                  <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="applyTrim()">
                    Apply Trim <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Apply" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        } @else {
        <!-- audio / image-audio preview -->
        <div class="fm-white-column">
          <div class="fm-previw-title">
            <div class="row align-items-center">
              <div class="col">
                <p class="fm-large fm-black-cl fw-semibold mb-0">Audio Preview</p>
              </div>
              <div class="col-auto">
                <span class="fm-tag"><img src="images/icons/fm-sizzer.svg" class="fm-svg" alt="Trim Icon" /> Trim Audio</span>
              </div>
            </div>
          </div>

          <div class="fm-stories-blog fm-stories-details mt-4">
            @if (mediaType() === 'image-audio' && imageUrl()) {
              <div class="fm-story-aimage">
                <img class="fm-story-image img-fluid w-100" [src]="imageUrl()!" alt="Story Image" />
              </div>
            }

            <div class="fm-golden-column">
              <div class="row">
                <div class="col-12 mt-3">
                  @if (videoUrl()) {
                    <audio #reviewAudio
                           class="fm-audio-player w-100 mb-3"
                           [src]="videoUrl()!"
                           controls
                           (loadedmetadata)="onAudioMetadataLoaded()"
                           (timeupdate)="onAudioTimeUpdate()"
                           (play)="onAudioPlay()"
                           (pause)="onAudioPause()"
                           (ended)="onAudioPause()"></audio>
                  } @else {
                    <div class="text-center py-3">
                      <img src="images/icons/fm-micro-icon.svg" class="fm-svg mb-2" alt="No Audio" style="width:48px;height:48px;opacity:0.45" />
                      <p class="mb-0 fm-small">No audio recorded/uploaded. Please go back and record.</p>
                    </div>
                  }
                  <!-- waveform: animated bars while playing, static SVG otherwise -->
                  @if (isAudioPlaying()) {
                    <div class="fm-audio-review-visualizer" aria-hidden="true">
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                      <span class="fm-arv-bar"></span>
                    </div>
                  } @else {
                    <img src="images/icons/fm-audio-wave.svg" class="fm-audio-wave-img img-fluid" alt="Audio Wave" />
                  }
                </div>
              </div>
            </div>

            @if (videoUrl()) {
              <div class="fm-golden-column fm-trim-cl">
                <div class="row align-items-center g-3">
                  <div class="col">
                    <h3 class="fm-heading-sm"><img src="images/icons/fm-sizzer-cl.svg" alt="Trim Icon" /> Trim Audio</h3>
                  </div>
                  <div class="col-auto">
                    <button type="button" class="fm-common-btn fm-border-btn" (click)="resetAudioTrim()">
                      <img src="images/icons/fm-reset.svg" alt="Reset Icon" /> Reset
                    </button>
                  </div>
                  <div class="col-12">
                    <p class="fm-small mt-1 mb-2">Drag sliders to set start and end points. Parts outside will be removed.</p>
                  </div>

                  <div class="col-12 mb-2">
                    <div class="fm-trim-strip-wrapper fm-audio-trim-strip" #audioTrimContainer>
                      <img src="images/icons/fm-audio-wave.svg" class="fm-audio-trim-wave" alt="" aria-hidden="true" />
                      <div class="fm-trim-exclude fm-trim-left-exclude" [style.width.%]="audioTrimStartPercent()"></div>
                      <div class="fm-trim-exclude fm-trim-right-exclude" [style.width.%]="audioTrimEndExcludePercent()"></div>
                      <div class="fm-trim-selection"
                           [style.left.%]="audioTrimStartPercent()"
                           [style.width.%]="audioTrimSelectionWidth()"></div>
                      <div class="fm-trim-handle fm-trim-handle-start" [style.left.%]="audioTrimStartPercent()"
                           (mousedown)="startAudioDragging('start', $event)"
                           (touchstart)="startAudioDragging('start', $event)">
                        <span class="fm-trim-handle-bar"></span>
                        <small class="fm-trim-time-label">{{ formatRecordingTime(audioTrimStart()) }}</small>
                      </div>
                      <div class="fm-trim-handle fm-trim-handle-end" [style.left.%]="audioTrimEndPercent()"
                           (mousedown)="startAudioDragging('end', $event)"
                           (touchstart)="startAudioDragging('end', $event)">
                        <span class="fm-trim-handle-bar"></span>
                        <small class="fm-trim-time-label">{{ formatRecordingTime(audioTrimEnd()) }}</small>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm">
                    <p class="fm-duretion-txt mb-0">
                      New duration: <span class="fw-semibold">{{ formatRecordingTime(audioTrimmedDuration()) }}</span>
                      (removed {{ formatRecordingTime(audioRemovedDuration()) }})
                    </p>
                  </div>
                  <div class="col-sm-auto">
                    <div class="fm-btn-group">
                      <button type="button" class="fm-common-btn fm-border-btn" (click)="resetAudioTrim()">Cancel</button>
                      <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="applyAudioTrim()">
                        Apply Trim <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Apply" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        }

        <div class="fm-white-column mt-4">
          <h3 class="fm-heading-sm">Story Title</h3>
          <div class="form-group mt-3">
            <input id="storyTitleInput" type="text" class="form-control fm-form-control fm-large-fl" [class.is-invalid]="titleError()" [ngModel]="storyTitle()" (ngModelChange)="storyTitle.set($event); titleError.set(false)" placeholder="My First Day of School" required />
            @if (titleError()) {
              <div class="invalid-feedback d-block">Story title is required.</div>
            }
          </div>
        </div>

        <div class="fm-white-column mt-4">
          <div class="accordion fm-accordion fm-accordion-st2">
            <div class="accordion-item fm-accordion-item mt-0">
              <span class="accordion-header fm-accordion-header">
                <button class="accordion-button fm-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#fmReviewTagPeople" aria-expanded="true" aria-controls="fmReviewTagPeople">Tag People in This Story</button>
                <p class="mb-1 fm-black-cl">Who is this memory about? Tag family members to organize your stories.</p>
              </span>

              <div id="fmReviewTagPeople" class="accordion-collapse fm-accordion-collapse collapse show"><div class="accordion-body fm-accordion-body"><p class="fm-black-cl fm-icon-content mb-2"><img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family Icon" /> Filter by Family</p>
                </div>

                <div class="fm-filter-tags fm-filter-selected">
                  <button type="button" class="fm-filter-tag fm-filter-tag-sm" [class.fm-ft-active]="selectedFamilySpaceId()==='all'" (click)="selectFamily('all')">All Family</button>
                  @for (family of familySpaces(); track family.familySpaceId) {
                    <button type="button" class="fm-filter-tag fm-filter-tag-sm" [class.fm-ft-active]="selectedFamilySpaceId()===family.familySpaceId" (click)="selectFamily(family.familySpaceId)">
                      {{ family.familyName }}
                    </button>
                  }
                </div>

                <div class="fm-card-group fm-filter-family fm-check-cards">
                  <div class="row g-3 mt-1">
                    @for (member of filteredFamilyMembers(); track member.familyMemberId) {
                      <div class="col-12 col-sm-6 col-xxl-4">
                        <input type="checkbox" class="fm-check-card-input" [id]="'fmTagMember-' + member.familyMemberId" [checked]="isTagged(member.familyMemberId)" (change)="toggleTaggedMember(member.familyMemberId)" />
                        <label class="fm-card-sm" [for]="'fmTagMember-' + member.familyMemberId">
                          <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" alt="Checked" /></div>
                          <div class="fm-card-img">
                            @if (hasMemberImage(member)) {
                              <img [src]="getMemberPhotoUrl(member)" class="fm-card-sm-image img-fluid" [alt]="member.fullName" (error)="onMemberImageError(member.familyMemberId)" />
                            } @else {
                              <div class="fm-card-sm-initials">{{ getMemberInitials(member) }}</div>
                            }
                          </div>
                          <div class="fm-card-content">
                            <p class="fm-card-name">{{ member.fullName }}</p>
                            <ul>
                              <li>{{ member.relationship || 'Family' }}</li>
                              <li><span class="fm-dot"></span></li>
                              <li>{{ getFamilyName(member) }}</li>
                            </ul>
                          </div>
                        </label>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="fm-white-column mt-4">
          <div class="accordion fm-accordion fm-accordion-st2">
            <div class="accordion-item fm-accordion-item mt-0">
              <span class="accordion-header fm-accordion-header">
                <button class="accordion-button fm-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#fmReviewSharing" aria-expanded="true" aria-controls="fmReviewSharing">Sharing Story</button>
                <p class="mb-1 fm-black-cl">Control who can see your story</p>
              </span>

              <div id="fmReviewSharing" class="accordion-collapse fm-accordion-collapse collapse show">
                <div class="accordion-body fm-accordion-body pt-0">
                  <div class="fm-card-group fm-filter-family fm-check-cards">
                    <div class="row g-3 g-lg-4 mt-1">
                      <div class="col-12 col-sm-6 col-xxl-4">
                        <input type="radio" name="sharingStory" id="fmSharePublic" class="fm-check-card-input" [checked]="sharingOption()==='public'" (change)="setSharingOption('public')" />
                        <label class="fm-card-sm" for="fmSharePublic">
                          <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" alt="Checked" /></div>
                          <div class="fm-card-img"><img src="images/earth-icon.svg" class="fm-card-sm-image" alt="Public" /></div>
                          <div class="fm-card-content"><p class="fm-card-name">Public Story</p><p class="fm-card-meta">Anyone can watch this story</p></div>
                        </label>
                      </div>

                      <div class="col-12 col-sm-6 col-xxl-4">
                        <input type="radio" name="sharingStory" id="fmSharePrivate" class="fm-check-card-input" [checked]="sharingOption()==='private'" (change)="setSharingOption('private')" />
                        <label class="fm-card-sm" for="fmSharePrivate">
                          <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" alt="Checked" /></div>
                          <div class="fm-card-img"><img src="images/lock-icon.svg" class="fm-card-sm-image" alt="Only Me" /></div>
                          <div class="fm-card-content"><p class="fm-card-name">Only Me</p><p class="fm-card-meta">Private, visible only to you</p></div>
                        </label>
                      </div>

                      <div class="col-12 col-sm-6 col-xxl-4">
                        <input type="radio" name="sharingStory" id="fmShareFamily" class="fm-check-card-input" [checked]="sharingOption()==='family'" (change)="setSharingOption('family')" />
                        <label class="fm-card-sm" for="fmShareFamily">
                          <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" alt="Checked" /></div>
                          <div class="fm-card-img"><img src="images/people-7.png" class="fm-card-sm-image" alt="Family Members" /></div>
                          <div class="fm-card-content"><p class="fm-card-name">All Family</p><p class="fm-card-meta">Share with selected family only</p></div>
                        </label>
                      </div>

                      @if (sharingOption()==='family') {
                        <div class="col-12 mt-2">
                          <p class="fm-black-cl fm-icon-content mb-2"><img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family Icon" /> Family List</p>
                          <div class="fm-filter-tags fm-filter-selected">
                            <button type="button" class="fm-filter-tag fm-filter-tag-sm" [class.fm-ft-active]="selectedSharingFamilyId()==='all'" (click)="selectSharingFamily('all')">All Family</button>
                            @for (family of familySpaces(); track family.familySpaceId) {
                              <button type="button" class="fm-filter-tag fm-filter-tag-sm" [class.fm-ft-active]="selectedSharingFamilyId()===family.familySpaceId" (click)="selectSharingFamily(family.familySpaceId)">
                                {{ family.familyName }}
                              </button>
                            }
                          </div>
                          <div class="fm-card-group fm-filter-family fm-check-cards">
                            <div class="row g-3 g-lg-4 mt-1">
                              @for (member of filteredSharingMembers(); track member.familyMemberId) {
                                <div class="col-12 col-sm-6 col-xxl-4">
                                  <input type="checkbox" class="fm-check-card-input" [id]="'fmShareMember-' + member.familyMemberId" [checked]="isShared(member.familyMemberId)" (change)="toggleSharedMember(member.familyMemberId)" />
                                  <label class="fm-card-sm" [for]="'fmShareMember-' + member.familyMemberId">
                                    <div class="fm-check-icon"><img src="images/icons/fm-check.svg" class="fm-svg" alt="Checked" /></div>
                                    <div class="fm-card-img">
                                      @if (hasMemberImage(member)) {
                                        <img [src]="getMemberPhotoUrl(member)" class="fm-card-sm-image img-fluid" [alt]="member.fullName" (error)="onMemberImageError(member.familyMemberId)" />
                                      } @else {
                                        <div class="fm-card-sm-initials">{{ getMemberInitials(member) }}</div>
                                      }
                                    </div>
                                    <div class="fm-card-content">
                                      <p class="fm-card-name">{{ member.fullName }}</p>
                                      <ul>
                                        <li>{{ member.relationship || 'Family' }}</li>
                                        <li><span class="fm-dot"></span></li>
                                        <li>{{ getFamilyName(member) }}</li>
                                      </ul>
                                    </div>
                                  </label>
                                </div>
                              }
                            </div>
                          </div>
                          @if (filteredSharingMembers().length === 0) {
                            <p class="fm-small text-muted mt-2 mb-0">No family members available.</p>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row fm-row-equal-cards">
          <div [ngClass]="mediaType() !== 'video' ? 'col-xl-6' : 'col-xl-12'">
            <div class="fm-white-column fm-match-height mt-4">
              <div class="accordion fm-accordion fm-accordion-st2">
                <div class="accordion-item fm-accordion-item mt-0">
                  <span class="accordion-header fm-accordion-header">
                    <button class="accordion-button fm-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#fmReviewStoryDetails" aria-expanded="true" aria-controls="fmReviewStoryDetails">Story Details</button>
                  </span>
                  <div id="fmReviewStoryDetails" class="accordion-collapse fm-accordion-collapse collapse show">
                    <div class="accordion-body fm-accordion-body pt-3">
                      <div class="row g-3 g-lg-4">
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label class="fm-form-label mb-2">Date</label>
                            <div class="fm-input-inline-icon">
                              <span class="fm-icon"><img class="fm-svg" src="images/icons/fm-calendar.svg" alt="Date Icon" /></span>
                              <input type="date" class="form-control fm-form-control" [ngModel]="storyDate()" (ngModelChange)="storyDate.set($event)" />
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label class="fm-form-label mb-2">Location</label>
                            <div class="fm-input-inline-icon">
                              <span class="fm-icon"><img class="fm-svg" src="images/icons/fm-location.svg" alt="Location Icon" /></span>
                              <input type="text" class="form-control fm-form-control" placeholder="Enter your location" [ngModel]="storyLocation()" (ngModelChange)="storyLocation.set($event)" />
                            </div>
                          </div>
                        </div>
                        <div class="col-12 mt-4">
                          <div class="form-group">
                            <label class="fm-form-label mb-2">Emotional Tone</label>
                            <select class="form-select fm-form-select" [value]="emotionalToneId()" (change)="onToneChange($event)">
                              <option [value]="0">Select a tone</option>
                              @for (tone of emotionalTones(); track tone.emotionalToneId) {
                                <option [value]="tone.emotionalToneId">{{ tone.toneName }}</option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          @if (mediaType() !== 'video') {
          <div class="col-xl-6">
            <div class="fm-white-column fm-match-height mt-4">
              <div class="accordion fm-accordion fm-accordion-st2">
                <div class="accordion-item fm-accordion-item mt-0">
                  <span class="accordion-header fm-accordion-header">
                    <button class="accordion-button fm-accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#fmReviewThumbnail" aria-expanded="true" aria-controls="fmReviewThumbnail">Upload Thumbnail <span class="text-danger ms-1">*</span></button>
                  </span>
                  <div id="fmReviewThumbnail" class="accordion-collapse fm-accordion-collapse collapse show">
                    <div class="accordion-body fm-accordion-body pt-3">
                      <div class="fm-thumbnail-upload-inline" [class.is-invalid-upload]="thumbnailError()">
                        @if (!thumbnailPreviewUrl()) {
                          <label for="fmReviewThumbnailInput" class="fm-thumbnail-upload-btn mb-0" [class.fm-upload-error]="thumbnailError()">
                            <img src="images/icons/fm-upload-icon.svg" class="fm-svg" alt="Upload Thumbnail" />
                            <span class="fm-upload-helper-text">Drop your photo here, or <span class="fm-browse-text">Browse</span></span>
                          </label>
                        } @else {
                          <div class="fm-thumbnail-preview">
                            <img [src]="thumbnailPreviewUrl()!" class="fm-thumbnail-preview-image" alt="Thumbnail Preview" />
                            <div class="fm-thumbnail-preview-info">
                              <span class="fm-thumbnail-preview-name">{{ thumbnailFileName() }}</span>
                              <span class="fm-thumbnail-preview-size">{{ thumbnailFileSize() }}</span>
                            </div>
                            <button type="button" class="fm-x-btn fm-thumbnail-remove-btn" (click)="removeThumbnail()" aria-label="Remove thumbnail">
                              <img src="images/icons/fm-x.svg" alt="Remove" />
                            </button>
                          </div>
                        }
                        <input type="file" id="fmReviewThumbnailInput" class="fm-thumbnail-file-input" accept="image/*"
                               (change)="onThumbnailUpload($event)" />
                      </div>
                      @if (thumbnailError()) {
                        <p class="text-danger fm-small mt-2 mb-0" role="alert">
                          Thumbnail is required for audio stories. Please upload a photo.
                        </p>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }

          <div class="col-xl-6 d-none">
            <div class="fm-white-column fm-match-height mt-4">
              <div class="accordion fm-accordion fm-accordion-st2">
                <div class="accordion-item fm-accordion-item mt-0">
                  <span class="accordion-header fm-accordion-header fm-border-bottom">
                    <button class="accordion-button fm-accordion-button fm-accordion-action" type="button" data-bs-toggle="collapse" data-bs-target="#fmReviewTranscript" aria-expanded="true" aria-controls="fmReviewTranscript">
                      <span class="fm-acc-title">Auto-Generated Transcript</span>
                      <span class="fm-edit-btn" (click)="toggleTranscriptEdit()">
                        <img [src]="transcriptEditMode() ? 'images/icons/fm-check-sm.svg' : 'images/icons/fm-edit.svg'" class="fm-svg" alt="Edit" />
                        {{ transcriptEditMode() ? 'Save' : 'Edit' }}
                      </span>
                    </button>
                  </span>

                  <div id="fmReviewTranscript" class="accordion-collapse fm-accordion-collapse collapse show">
                    <div class="accordion-body fm-accordion-body pt-2">
                      <div class="fm-tabbar fm-tabbar-st2">
                        <ul class="nav nav-tabs fm-nav-tabs fm-nav-tabs-st2" role="tablist">
                          <li class="fm-nav-item" role="presentation">
                            <button class="fm-nav-link" [class.active]="transcriptTab()==='verbatim'" type="button" (click)="setTranscriptTab('verbatim')">Verbatim</button>
                          </li>
                          <li class="fm-nav-item" role="presentation">
                            <button class="fm-nav-link" [class.active]="transcriptTab()==='narrative'" type="button" (click)="setTranscriptTab('narrative')">Narrative</button>
                          </li>
                        </ul>
                      </div>

                      <div class="tab-content mt-3">
                        <div class="tab-pane fade show active" tabindex="0">
                          <div class="form-group">
                            <textarea
                              class="form-control fm-transcript-textarea"
                              rows="6"
                              [readOnly]="!transcriptEditMode()"
                              [value]="activeTranscriptText()"
                              (input)="onTranscriptInput($event)"
                            ></textarea>
                          </div>
                          <p class="mt-3 mb-0 fm-light fm-small">AI-generated transcript. Click Edit to refine before publishing.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="fm-form-footer fm-space-between mt-4">
          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="backToRecording()">
            <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
            Back to Recording
          </button>
          @if (publishError()) {
            <p class="text-danger mb-0 me-3 small">{{ publishError() }}</p>
          }
          <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" [disabled]="isPublishing()" (click)="openPublishConfirm()">
            Save and Publish <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Publish" />
          </button>
        </div>
      </div>

      <div class="col-lg-4 col-xxl-auto mt-4 mt-lg-0">
        <div class="fm-sidebar-clumn">
          <div class="fm-border-column fm-color-brd">
            <div class="row">
              <div class="col-12">
                <h3 class="fm-head-20 fm-sidebar-title">Before Publishing</h3>
              </div>
              <div class="col-12">
                <div class="fm-recording-tips-list">
                  <div class="fm-detail-item align-items-center"><img class="fm-svg me-1" src="images/icons/fm-check-md.svg" alt="Check" /><div class="fm-detail-content"><p class="fm-detail-text">Review video and trim if needed</p></div></div>
                  <div class="fm-detail-item align-items-center"><img class="fm-svg me-1" src="images/icons/fm-check-md.svg" alt="Check" /><div class="fm-detail-content"><p class="fm-detail-text">Tag people this story is about</p></div></div>
                  <div class="fm-detail-item align-items-center"><img class="fm-svg me-1" src="images/icons/fm-check-md.svg" alt="Check" /><div class="fm-detail-content"><p class="fm-detail-text">Add date and location details</p></div></div>
                  <div class="fm-detail-item align-items-center"><img class="fm-svg me-1" src="images/icons/fm-check-md.svg" alt="Check" /><div class="fm-detail-content"><p class="fm-detail-text">Review AI transcript for accuracy</p></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>


  <!-- Publish Confirmation Modal -->
  @if (showPublishConfirm()) {
    <div class="fm-reload-overlay" role="dialog" aria-modal="true" aria-labelledby="publishConfirmTitle">
      <div class="fm-reload-modal">
        <div class="fm-reload-modal-icon fm-reload-modal-icon--primary">
          <img src="images/icons/fm-check-md.svg" class="fm-svg" alt="Publish" />
        </div>
        <h3 class="fm-reload-modal-title" id="publishConfirmTitle">Ready to Publish?</h3>
        <p class="fm-reload-modal-desc">Your story <strong>"{{ storyTitle() }}"</strong> will be saved and published. This cannot be undone.</p>
        <div class="fm-reload-modal-actions">
          <button type="button" class="fm-common-btn fm-primary-btn" (click)="saveAndPublish()">Yes, Publish Now</button>
          <button type="button" class="fm-reload-leave-btn" (click)="cancelPublish()">Cancel</button>
        </div>
      </div>
    </div>
  }

  <!-- Global Publishing Loader -->
  @if (isPublishing()) {
    <div class="fm-publishing-overlay" role="status" aria-live="polite" aria-label="Publishing your story">
      <div class="fm-publishing-loader-box">
        <div class="spinner-border fm-publishing-spinner" role="status" aria-hidden="true"></div>
        <p class="fm-publishing-label">Publishing your story…</p>
      </div>
    </div>
  }

  <!-- Reload Warning Modal -->
  @if (showReloadWarning()) {
    <div class="fm-reload-overlay" role="dialog" aria-modal="true" aria-labelledby="reloadModalTitle">
      <div class="fm-reload-modal">
        <div class="fm-reload-modal-icon">
          <span>&#9888;</span>
        </div>
        <h3 class="fm-reload-modal-title" id="reloadModalTitle">Leave this page?</h3>
        <p class="fm-reload-modal-desc">Your story progress will be <strong>permanently lost</strong> if you refresh or leave. You'll need to start the entire process again.</p>
        <div class="fm-reload-modal-actions">
          <button type="button" class="fm-common-btn fm-primary-btn" (click)="dismissReloadWarning()">Stay &amp; Continue</button>
          <button type="button" class="fm-reload-leave-btn" (click)="confirmReload()">Leave anyway</button>
        </div>
      </div>
    </div>
  }
</div>
